document.addEventListener('DOMContentLoaded', function () {
  // Accordion click
  document.querySelectorAll('.toggle-heading').forEach(heading => {
    heading.addEventListener('click', function () {
      const parentBlock = this.closest('.blog-sidebar-block');
      const content = parentBlock.querySelector('.sidebar-accordion-content');
      const moreBtn = parentBlock.querySelector('.toggle-button');
      const hiddenItems = content.querySelectorAll('.hidden-item');

      this.classList.toggle('active');
      content.classList.toggle('filter-accordion-active');

      // Show More button only if hidden items exist
      if (hiddenItems.length > 0) {
        moreBtn.classList.add('show');
        moreBtn.textContent = 'More';
        hiddenItems.forEach(item => item.classList.remove('show'));
      } else {
        moreBtn.classList.remove('show');
      }
    });
  });

  // More/Hide click
  document.querySelectorAll('.toggle-button').forEach(button => {
    button.addEventListener('click', function () {
      const target = document.querySelector(this.dataset.target);
      const hiddenItems = target.querySelectorAll('.hidden-item');

      const isExpanded = this.textContent === 'More';
      hiddenItems.forEach(item => {
        item.classList.toggle('show', isExpanded);
      });
      this.textContent = isExpanded ? 'Hide' : 'More';
    });
  });


    function removeFilterAccordionForMobile() {
      if (window.innerWidth <= 750) {
        document.querySelectorAll('.sidebar-accordion-content')
          .forEach(el => el.classList.remove('filter-accordion-active'));

        document.querySelectorAll('.toggle-heading').forEach(heading => {
          heading.classList.remove('active');
        });
      }
    }

    removeFilterAccordionForMobile();
    window.addEventListener('resize', removeFilterAccordionForMobile);
});
